<template>
  <div>
    <h3>Data Protection</h3>
    <div class="p-3 mb-2">
      <p>
        The operators of these pages take the protection of your personal data very seriously. We treat your personal data confidentially and in accordance with the applicable data protection regulations and this privacy policy.
      </p>
      <p>
        The use of our website is generally possible without providing personal data. If personal data (such as name, address, or email addresses) is collected on our pages, it is always done on a voluntary basis, to the extent possible. This data will not be disclosed to third parties without your express consent.
      </p>
      <p>
        Please note that data transmission over the Internet (e.g., communication via email) may have security vulnerabilities. A complete protection of the data from access by third parties is not possible.
      </p>

      <h4>Cookies</h4>
      <p>
        Our website uses cookies in some areas. Cookies do not harm your computer and do not contain viruses. They serve to make our offer more user-friendly, effective, and secure. Cookies are small text files that are stored on your computer and saved by your browser.
      </p>
      <p>
        Most of the cookies we use are so-called "session cookies," which are automatically deleted at the end of your visit. Other cookies remain stored on your device until you delete them. These cookies allow us to recognize your browser on your next visit.
      </p>
      <p>
        You can configure your browser to inform you about the use of cookies and allow cookies only in individual cases, exclude the acceptance of cookies for specific cases or in general, as well as activate the automatic deletion of cookies when closing the browser. The functionality of this website may be restricted when cookies are deactivated.
      </p>

      <h4>Server Log Files</h4>
      <p>
        The provider of the pages automatically collects and stores information in so-called server log files, which your browser automatically transmits to us. These are:
      </p>
      <ul>
        <li>Browser type and version</li>
        <li>Operating system used</li>
        <li>Referrer URL</li>
        <li>Hostname of the accessing computer</li>
        <li>Time of the server request</li>
      </ul>
      <p>
        These data cannot be assigned to specific persons. A merging of this data with other data sources is not carried out. We reserve the right to check this data subsequently if we become aware of concrete indications of illegal use.
      </p>

      <h4>Google Web Fonts</h4>
      <p>
        This page uses so-called web fonts provided by Google for the uniform display of fonts. When you call up a page, your browser loads the required web fonts into your browser cache to display texts and fonts correctly. If your browser does not support web fonts, a standard font will be used by your computer.
      </p>
      <p>
        Further information on Google Web Fonts can be found at
        <a href="https://developers.google.com/fonts/faq" target="_blank" rel="noopener">https://developers.google.com/fonts/faq</a>
        and in Google's privacy policy:
        <a href="https://www.google.com/policies/privacy/" target="_blank" rel="noopener">https://www.google.com/policies/privacy/</a>
      </p>

      <h4>SSL Encryption</h4>
      <p>
        For security reasons and to protect the transmission of confidential content, such as inquiries you send to us as the site operator, this site uses SSL encryption. You can recognize an encrypted connection by the fact that the address line of the browser changes from "http://" to "https://" and by the lock symbol in your browser line.
      </p>
      <p>
        When SSL encryption is activated, the data you transmit to us cannot be read by third parties.
      </p>

      <h4>Right to Information, Deletion, Blocking</h4>
      <p>
        You have the right to free information about your stored personal data, its origin and recipients, and the purpose of data processing, as well as the right to correction, blocking, or deletion of this data. For this purpose and for further questions regarding personal data, you can contact us at any time using the address provided in the imprint.
      </p>
    </div>
    <router-link class="btn btn-secondary" to="/start"><i class="fas fa-arrow-left pr-2"></i> Back</router-link>
  </div>
</template>

<script>
export default {
	name: 'privacy'
};
</script>
